import React, { useState, useEffect } from "react";
import axios from "axios";
import SideNav from "../Dashboard/SideNav";
import Navbar from "../Dashboard/Navbar";
import "../Dashboard/styles.css";

export default function AdminList() {
  const [admins, setAdmins] = useState([]);

  useEffect(() => {
    axios
      .get("https://journey-scape-main.vercel.app/api/auth/admins")
      .then((response) => {
        setAdmins(response.data.admins);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleDeleteAdmin = async (adminId, email) => {
    if (email === "zkashif040@gmail.com" || email === "sameerhassan888@gmail.com") {
      console.log("Cannot delete this admin.");
      return;
    }

    try {
      await axios.delete(`https://journey-scape-main.vercel.app/api/auth/admins/${adminId}`);
      setAdmins(admins.filter((admin) => admin._id !== adminId));
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Navbar />
      <SideNav />
      <div className="db-info-wrap">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-box table-opp-color-box">
              <h4>Admin List</h4>
              <p>Number of admin users registered on the JourneyScape Website.</p>
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {admins.map((admin) => (
                      <tr key={admin._id}>
                        <td>
                          <span className="list-name">{admin.name}</span>
                        </td>
                        <td>{admin.email}</td>
                        <td>
                          {admin.email === "zkashif040@gmail.com" || admin.email === "sameerhassan888@gmail.com" ? (
                            <span className="badge bg-secondary">
                              <i className="fas fa-lock" />
                            </span>
                          ) : (
                            <span className="badge bg-danger" onClick={() => handleDeleteAdmin(admin._id, admin.email)}>
                              <i className="far fa-trash-alt" />
                            </span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
